export function isFilled(value) {
  return String(value ?? "").trim() !== "";
}

export function isEmailFilled(value) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value ?? "").trim());
}

export function requiredFieldsFilled(values) {
  return values.every(isFilled);
}
